




























































import { Component, Vue, Provide, Watch } from "vue-property-decorator";

interface NavMenuItem {
  label: string;
  url: string;
  dataRef: string;
}

interface NavLink {
  label: string;
  url?: string;
  menuItems?: Array<NavMenuItem>;
  dataRef: string;
}

@Component({
  components: {},
})
export default class App extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Watch("$store.state.error")
  focusErrorAlert() {
    if (this.error !== "") {
      (this.$refs.container as any).scrollIntoView();
    }
  }

  data() {
    return { drawer: false, publicPath: "/" };
  }

  get widget() {
    return this.$store.state.widget;
  }

  get isLoading() {
    return this.$store.state.loading;
  }

  get user() {
    return this.$store.state.user;
  }

  get avataxRole() {
    return this.$store.state.avataxRole;
  }

  get error() {
    return this.$store.state.error;
  }

  get success() {
    return this.$store.state.success;
  }

  get toast() {
    return this.$store.state.toast;
  }

  get navs() {
    const navLinks: Array<NavLink> = [
      {
        label: "Home",
        url: "/",
        dataRef: "aui-supernav.home",
      },
    ];
    const bulkLevel = this.$store.getters.featureLevel("item-classification");
    if (!this.$_.isEmpty(bulkLevel) && bulkLevel != "disabled") {
      const classificationsItem = {
        label: "Tax category classifications",
        url: `/classification/${this.$store.getters.accountID}/${this.$store.getters.companyID}/jobs`,
        dataRef: "aui-supernav.classification.classificationsList",
      };
      const profilesItem = {
        label: "Classification profiles",
        url: `/classification/${this.$store.getters.accountID}/${this.$store.getters.companyID}/profiles`,
        dataRef: "aui-supernav.classification.profilesList",
      };
      const schemasItem = {
        label: "Classification schemas",
        url: `/classification/${this.$store.getters.accountID}/${this.$store.getters.companyID}/schemas`,
        dataRef: "aui-supernav.classification.schemasList",
      };
      const bulkNavLink = {
        label: "Tax category classification",
        menuItems:
          bulkLevel != "restricted"
            ? [classificationsItem, profilesItem, schemasItem]
            : [classificationsItem],
        dataRef: "aui-supernav.classification.menu-trigger",
      };
      navLinks.push(bulkNavLink);
    }
    if (
      !this.$_.isEmpty(this.$store.getters.featureLevel("taxability")) &&
      this.$store.getters.featureLevel("taxability") === "enabled"
    ) {
      navLinks.push({
        label: "Taxability Matrix",
        url: "/taxability",
        dataRef: "aui-supernav.taxability",
      });
    }
    return navLinks;
  }

  resolveHerculeRole(herculeRoles) {
    const rolesOrderedByAccessLevel = [
      "ClassificationInternalExpert",
      "ClassificationInternalRep",
      "ClassificationAdmin",
      "AuthenticatedUser",
      "Guest",
    ];
    for (const roleByAccessLevel of rolesOrderedByAccessLevel) {
      if (herculeRoles.indexOf(roleByAccessLevel) >= 0) {
        return roleByAccessLevel;
      }
    }
  }

  convertUserForHeader(user) {
    if (!user) {
      return user;
    }
    const { givenName, familyName, email, isLoggedIn } = user;
    const avataxAccountId = user.customerAvataxAccountId
      ? user.customerAvataxAccountId
      : user.avataxAccountId;
    const isTechSupport = user.herculeRoles
      ? user.herculeRoles.includes("SupportUser")
      : false;
    const switchAccountsUrl = isTechSupport ? "/support/switchaccount" : "";
    const headerUser = {
      avataxAccountId: avataxAccountId,
      givenName: givenName,
      familyName: familyName,
      email: email,
      isLoggedIn: isLoggedIn,
      isTechSupport: isTechSupport,
      switchAccountsUrl: switchAccountsUrl,
    };
    return headerUser;
  }

  activeNavItem() {
    const currentNavLabel = this.$router.currentRoute.meta.navLabel;
    return (
      this.navs.find((navLink) => navLink.label === currentNavLabel)?.dataRef ||
      "aui-supernav.home"
    );
  }

  @Watch("$store.state.toast")
  triggerToast() {
    const toastData = {
      text: this.$store.state.toast,
      id: "toast",
      ariaLabel: this.$store.state.toast,
      status: "success",
    };
    (this.$refs["toast"] as any).createToast(toastData);
  }

  created() {
    this.$store.state.user = (window as any).user;
    this.$store.state.widget =
      this.$route.query.widget && this.$route.query.widget === "true";
    this.$store.commit("recordAssetsPath", (window as any).assetsPath);
    this.$store.commit(
      "recordAssetsPathGlobal",
      (window as any).assetsPathGlobal
    );

    if ((window as any).auiSession) {
      this.$store.commit(
        "recordSessionExpiry",
        (window as any).auiSession.accessTokenExpireTime
      );
    }
    if ((window as any).user && (window as any).user.herculeFeatures) {
      this.$store.commit(
        "recordHerculeFeatures",
        (window as any).user.herculeFeatures
      );
    }
    if ((window as any).user && (window as any).user.herculeRoles) {
      const roles = (window as any).user.herculeRoles;
      const resolvedRole = this.resolveHerculeRole(roles);
      this.$store.commit("recordHerculeRole", resolvedRole);
    }
    if (
      (window as any).userDetails &&
      (window as any).userDetails.companies &&
      (window as any).userDetails.companies.length > 0
    ) {
      this.$store.commit(
        "recordCompanies",
        (window as any).userDetails.companies
      );
    }
    if ((window as any).userDetails && (window as any).userDetails.avataxRole) {
      this.$store.commit(
        "recordAvataxRole",
        (window as any).userDetails.avataxRole
      );
    }
    if (
      (window as any).userDetails &&
      (window as any).userDetails.bulkCustomerId &&
      (window as any).userDetails.bulkCustomerId !== -1
    ) {
      this.$store.commit(
        "recordBulkCustomerId",
        (window as any).userDetails.bulkCustomerId
      );
    }
    if (
      (window as any).analyticsScript &&
      !this.$_.isEmpty((window as any).analyticsScript)
    ) {
      this.$store.commit(
        "recordAnalyticsScript",
        (window as any).analyticsScript
      );
    }
  }
}
